/* eslint-disable no-console */
import React, { useContext, useEffect, useState } from 'react';
import { getFeedById } from '../../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import Loading from '../../../../../components/Common/Loaders/FullWidthLoader/Loading';
import FeedCard from '../FeedCards/Card';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from '../../../../../libs/Context';

const IndividualFeed = (props: any) =>
{
	const { postId, scheduled = false } = props;
	const session = useSelector((state: any) => state.mysession.session);
	const [ feedList, setFeedList ] = useState<any>([]);
	const [ loading, setLoading ] = useState(false);
	const navigate = useNavigate();
	const { language } = useContext(LanguageContext);
	const requestId = window.atob(postId);
	const BASE_QUERY: any = {
		uid     : session?.userId,
		comid   : session?.companyId,
		empRole : session?.empRole,
		role    : session?.role
	};

	const fetchFeedData = async () =>
	{
		setLoading(true);
		try
		{
			const res = await getFeedById(requestId, BASE_QUERY);

			if (res?.status)
			{
				setFeedList(res?.data);
				const elem = document.getElementById('individual_post_name');

				if (elem)
				{
					elem.innerHTML = res?.data?.userData?.role === 'company'
						? res?.data?.userData?.companyName
						: res?.data?.userData?.fullName || res?.data?.creatorName;
				}
			}
			else
			{
				toast.error(res?.error || language.feedNotFound);
				navigate('/news');
			}
		}
		catch (error)
		{
			console.error('Error fetching feed:', error);
			toast.error(language.feedNotFound);
			navigate('/news');
		}
		finally
		{
			setLoading(false);
		}
	};

	useEffect(() =>
	{
		if (requestId) fetchFeedData();
	}, [ requestId ]);

	if (loading)
	{
		return <Loading />;
	}

	return (
		<Grid container pb='var(--pixel16)' xs={12} item>
			<FeedCard
				key={requestId}
				item={feedList}
				index={0}
				scheduled={scheduled}
				refreshFeedData={() => {}}
			/>
		</Grid>
	);
};

export default IndividualFeed;
